import { getSonarObjectTypeLabelPlural } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { UnorderedListOutlined } from '@ant-design/icons';

export interface SearchTypeLabelProps {
	sonarObjectType: SonarObjectType;
}

export const SearchTypeLabel: React.FC<SearchTypeLabelProps> = ({ sonarObjectType }) =>
	<>
		<UnorderedListOutlined />
		&nbsp;{ getSonarObjectTypeLabelPlural(sonarObjectType) }
	</>;

